/**
 * menu redux actions
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {
    LOAD_MENU,
    SELECT_MENU_ITEM,
    SET_FILTER,
    SET_SUB_FILTERS
} from "./consts";


export const loadMenuAction = (items) => ({
    type: LOAD_MENU,
    items: items
});

export const selectMenuItemAction = (selectedItem, openedItems) => ({
    type: SELECT_MENU_ITEM,
    selectedItem: selectedItem,
    openedItems: openedItems
});

export const setFilterAction = (filter) => ({
    type: SET_FILTER,
    filter: filter
});

export const setSubFiltersAction = (filterId, subFilters) => ({
    type: SET_SUB_FILTERS,
    filterId: filterId,
    subFilters: subFilters
});
